export const NETWORK_ERROR_403 = 403;